import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Validator function that checks if the given form control's value is a valid hyperlink (href).
 *
 * This function validates whether the value of the form control is a correctly formatted link.
 *
 * @return A validation function that accepts an `AbstractControl` as input and returns either a `ValidationErrors` object
 *         if the value is invalid or `null` if the value is valid.
 */
export function hrefValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    return validateHref(value);
  };
}

/**
 * Validates a given string to check if it adheres to URL href standards.
 * The method ensures the value is a valid URL with optional protocol, domain, port, and path.
 *
 * @param {string} value - The string value to be validated as a URL href.
 * @return {ValidationErrors | null} An object containing validation errors if the string is invalid, or null if it is valid.
 */
export function validateHref(value: string): ValidationErrors | null {
  const errors: ValidationErrors = {};

  const isValid =
    /^(https?:\/\/)([\w\d\-_]+(\.[\w\d\-_]+)+)(:\d+)?(\/[^\s]*)?$/.test(value);

  // If the value is invalid, return an error object; otherwise, return null
  return isValid ? null : { href: true };
}
